import { GridColumnConfig } from '../../../../../models/gridCoumnConfig';

export const noteColumns: GridColumnConfig[] = [
  {
    title: 'Topic',
    field: 'topic',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Subtitle (Optional)',
    field: 'subTitle',
    filter: 'text',
    searchable: true,
  },

  {
    title: 'Description',
    field: 'note',
    filter: 'text',
    searchable: true,
  },
];
